<template>
  <v-container fluid class="pa-2" style="margin-top: 2%; max-width: 100%">
    <template>
      <v-row justify="center">
        <v-dialog v-model="confirmDialog" persistent max-width="500">
          <v-card>
            <v-card-title class="headline">
              <span style="color: #d60000">{{ $t('system.alert') }}</span>
            </v-card-title>
            <v-card-text>
              <span style="color: #d60000">{{ this.mensagemdialog }}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red accent-4" class="white--text" @click="confirmDialog = false">{{
                this.messageDismissButton }}</v-btn>
              <v-btn v-if="showConfirmButton" color="red accent-4" class="white--text" @click="deleteFromDatabase">{{
                this.messageConfirmButton }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <recursos-operacionais-split-layout
      ref="detalheSplit"
      :linha="linhaSelecionada"
      preview-type="fence"
      :preview-item="cercaSelecionada"
      :preview-items="selecionadas"
      :initial-tab="initialDetailTab"
      :parametros-total="selecionadas.length"
      :parametros-page.sync="parametrosPage"
      :parametros-label="parametrosLabel"
      :token="token"
      :can-edit="canEdit"
      :can-insert="canInsert"
      @map-action="onMapAction"
      @preview-changed="onPreviewChanged"
      @parametros-save="saveParametros"
    >
      <template #parametros>
        <v-form ref="formParametros" v-model="formValidado">
          <v-row>
            <v-col cols="12" sm="3" md="2">
              <v-text-field v-model="editedItem.cod_cerca" :label="$t('geofence.code')"
                :rules="[codCercaRules]"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-text-field v-model="editedItem.nome_cerca" :label="$t('geofence.name')"
                :rules="[nomeCercaRules]"></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="2">
              <v-text-field v-model="editedItem.cod_integracao" :label="$t('geofence.integrationCode')"
                :rules="[codIntegracaoRules]" maxlength="50" clearable></v-text-field>
            </v-col>
            <v-col cols="12" sm="2" md="2">
              <v-switch v-model="editedItem.ativa" class="ma-2" :label="$t('geofence.active')"></v-switch>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete v-model="editedItem.id_empresa" :items="empresas" item-text="razao_social"
                item-value="id_empresa" clearable :label="$t('area.selectCompany')"
                :disabled="isScopedClienteCreateLock"></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete v-model="editedItem.id_cliente" :items="clientesFiltrados"
                item-text="labelCliente" item-value="id_cliente" clearable
                :disabled="isScopedClienteCreateLock || !editedItem.id_empresa"
                :label="$t('geofence.selectClient')"></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <div class="caption grey--text mb-1">{{ $t('geofence.format') }}</div>
              <v-radio-group
                v-model="editedItem.is_circular"
                row
                dense
                class="mt-0 mb-2"
                hide-details="auto"
                :rules="[formatoCercaRules]"
                @change="circularChanged"
              >
                <v-radio :label="$t('geofence.formatCircular')" :value="1" />
                <v-radio :label="$t('geofence.formatPolygon')" :value="0" />
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4" md="4">
              <v-text-field v-model="editedItem.raio_mts" :label="$t('geofence.radius')" type="number"
                min="1" suffix="m" hide-spin-buttons :disabled="editedItem.is_circular == 0" @change="radiusChanged"
                :rules="[raioRules]"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-text-field v-model="editedItem.lat_centro" :label="$t('geofence.latitude')" @change="getMarkerFromLatLong"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-text-field v-model="editedItem.lng_centro" :label="$t('geofence.longitude')" @change="getMarkerFromLatLong"></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="editedItem.is_circular != 1">
            <v-col cols="12">
              <div class="d-flex align-center flex-wrap mb-1">
                <v-btn
                  small
                  class="mr-2 mb-1"
                  :color="desenhoPoligonoAtivo ? 'warning' : 'primary'"
                  dark
                  @click="toggleDesenhoPoligono"
                >
                  <v-icon left small>mdi-vector-polygon</v-icon>
                  {{ $t('crudLinhas.map.controls.drawPolygon') }}
                </v-btn>
                <v-chip
                  v-if="contagemVerticesPoligono > 0"
                  x-small
                  class="mr-2 mb-1"
                  color="primary"
                  text-color="white"
                >
                  {{ $t('geofence.polygonDefined', { count: contagemVerticesPoligono }) }}
                </v-chip>
                <v-btn
                  v-if="contagemVerticesPoligono > 0"
                  x-small
                  text
                  class="mb-1"
                  @click="limparPoligonoFormulario"
                >
                  {{ $t('button.clear') }}
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="3">
              <v-switch v-model="alarmeEntrada" class="ma-2" :label="$t('geofence.entranceAlarm')"></v-switch>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-switch v-model="alarmeSaida" class="ma-2" :label="$t('geofence.exitAlarm')"></v-switch>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-switch v-model="alarmeVelocidade" class="ma-2" :label="$t('system.labels.speed')"></v-switch>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="editedItem.velocidade_maxima" :label="$t('geofence.maxSpeed')"
                type="number" min="1" hide-spin-buttons :rules="[velocidadeRules]"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="11" md="11">
              <v-text-field v-model="editedItem.endereco" :label="$tc('address.self', 1)"
                counter="300" clearable single-line dense prepend-icon="mdi-map-marker"
                :rules="[(v) => (v === null || v.length <= 300) || $t('geofence.addressCharacterLimit')]">
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="1" md="1">
              <v-btn fab color="primary" dark small class="mb-2" @click="getMarkerFromEndereco"
                :loading="loadingEndereco">
                <v-icon>mdi-map-search</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-textarea clearable clear-icon="mdi-close-circle" v-model="editedItem.observacoes"
                :label="$tc('system.labels.observation', 2)" :rules="[observacoesRules]">
              </v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </template>
      <template #create-entity>
        <v-form ref="formCreate" v-model="formValidado" class="pa-2">
          <v-text-field
            v-model="editedItem.cod_cerca"
            :label="$t('geofence.code')"
            :rules="createValidationAttempted ? [codCercaRules] : []"
            dense
            outlined
          />
          <v-text-field
            v-model="editedItem.nome_cerca"
            :label="$t('geofence.name')"
            :rules="createValidationAttempted ? [nomeCercaRules] : []"
            dense
            outlined
          />
          <v-text-field
            v-model="editedItem.cod_integracao"
            :label="$t('geofence.integrationCode')"
            :rules="createValidationAttempted ? [codIntegracaoRules] : []"
            maxlength="50"
            clearable
            dense
            outlined
          />
          <v-switch v-model="editedItem.ativa" class="mt-0 mb-2" hide-details :label="$t('geofence.active')" />
          <v-autocomplete
            v-model="editedItem.id_empresa"
            :items="empresas"
            item-text="razao_social"
            item-value="id_empresa"
            clearable
            dense
            outlined
            :label="$t('area.selectCompany')"
            :disabled="isScopedClienteCreateLock"
          />
          <v-autocomplete
            v-model="editedItem.id_cliente"
            :items="clientesFiltrados"
            item-text="labelCliente"
            item-value="id_cliente"
            clearable
            dense
            outlined
            :disabled="isScopedClienteCreateLock || !editedItem.id_empresa"
            :label="$t('geofence.selectClient')"
            class="mb-2"
          />
          <div class="caption grey--text mb-1">{{ $t('geofence.format') }}</div>
          <v-radio-group
            v-model="editedItem.is_circular"
            row
            dense
            class="mt-0 mb-2"
            hide-details="auto"
            :rules="createValidationAttempted ? [formatoCercaRules] : []"
            @change="circularChanged"
          >
            <v-radio :label="$t('geofence.formatCircular')" :value="1" />
            <v-radio :label="$t('geofence.formatPolygon')" :value="0" />
          </v-radio-group>
          <v-text-field
            v-model="editedItem.raio_mts"
            :label="$t('geofence.radius')"
            type="number"
            min="1"
            suffix="m"
            hide-spin-buttons
            dense
            outlined
            :disabled="editedItem.is_circular == 0"
            :rules="createValidationAttempted ? [raioRules] : []"
            class="mb-2"
            @change="radiusChanged"
          />
          <div class="d-flex align-center mb-2">
            <v-text-field
              v-model="editedItem.lat_centro"
              :label="$t('geofence.latitude')"
              dense
              outlined
              hide-details="auto"
              class="flex-grow-1 mr-2"
              @change="getMarkerFromLatLong"
            />
            <v-text-field
              v-model="editedItem.lng_centro"
              :label="$t('geofence.longitude')"
              dense
              outlined
              hide-details="auto"
              class="flex-grow-1"
              @change="getMarkerFromLatLong"
            />
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  fab
                  x-small
                  dark
                  class="ml-2"
                  :color="pickLocationAtivo ? 'warning' : 'primary'"
                  @click="togglePickLocation"
                >
                  <v-icon small>mdi-map-marker-plus</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('geofence.pickOnMap') }}</span>
            </v-tooltip>
          </div>
          <div v-if="editedItem.is_circular != 1" class="mb-3">
            <div class="d-flex align-center flex-wrap mb-1">
              <v-btn
                small
                class="mr-2 mb-1"
                :color="desenhoPoligonoAtivo ? 'warning' : 'primary'"
                dark
                @click="toggleDesenhoPoligono"
              >
                <v-icon left small>mdi-vector-polygon</v-icon>
                {{ $t('crudLinhas.map.controls.drawPolygon') }}
              </v-btn>
              <v-chip
                v-if="contagemVerticesPoligono > 0"
                x-small
                class="mr-2 mb-1"
                color="primary"
                text-color="white"
              >
                {{ $t('geofence.polygonDefined', { count: contagemVerticesPoligono }) }}
              </v-chip>
              <v-btn
                v-if="contagemVerticesPoligono > 0"
                x-small
                text
                class="mb-1"
                @click="limparPoligonoFormulario"
              >
                {{ $t('button.clear') }}
              </v-btn>
            </div>
            <div v-if="createValidationAttempted && !editedItem.shape" class="caption red--text">
              {{ $t('geofence.shapeRequired') }}
            </div>
          </div>
          <v-switch v-model="alarmeEntrada" class="mt-0 mb-1" hide-details :label="$t('geofence.entranceAlarm')" />
          <v-switch v-model="alarmeSaida" class="mt-0 mb-1" hide-details :label="$t('geofence.exitAlarm')" />
          <v-switch v-model="alarmeVelocidade" class="mt-0 mb-2" hide-details :label="$t('system.labels.speed')" />
          <v-text-field
            v-model="editedItem.velocidade_maxima"
            :label="$t('geofence.maxSpeed')"
            type="number"
            min="1"
            hide-spin-buttons
            dense
            outlined
            :rules="createValidationAttempted ? [velocidadeRules] : []"
            class="mb-2"
          />
          <div class="d-flex align-center mb-2">
            <v-text-field
              v-model="editedItem.endereco"
              :label="$tc('address.self', 1)"
              counter="300"
              clearable
              dense
              outlined
              hide-details="auto"
              prepend-icon="mdi-map-marker"
              :rules="createValidationAttempted ? [(v) => (v === null || v.length <= 300) || $t('geofence.addressCharacterLimit')] : []"
              class="flex-grow-1"
            />
            <v-btn fab color="primary" dark x-small class="ml-2" @click="getMarkerFromEndereco" :loading="loadingEndereco">
              <v-icon small>mdi-map-search</v-icon>
            </v-btn>
          </div>
          <v-textarea
            clearable
            clear-icon="mdi-close-circle"
            v-model="editedItem.observacoes"
            :label="$tc('system.labels.observation', 2)"
            :rules="createValidationAttempted ? [observacoesRules] : []"
            dense
            outlined
            class="mb-2"
          />
          <div class="d-flex justify-end pt-2">
            <v-btn color="primary darken-1" class="white--text mr-2" small @click="close">
              {{ $t('button.cancel') }}
            </v-btn>
            <v-btn color="primary darken-1" class="white--text" small @click="save">
              {{ $t('button.save') }}
            </v-btn>
          </div>
        </v-form>
      </template>
    <merus-data-table :headers="headers" :items="cercas" mostrar-inativos :loading="loadingtable" :default-multi-sort="defaultSort"
      :loading-text="$t('geofence.loading')"
      :server-items-length="totalCercas" :items-per-page="numberOfRows"
      :items-per-page-last-option="itemsPerPageLastOption"
      :server-sort-by="serverSortBy" :server-sort-desc="serverSortDesc"
      @update:options="onTableOptions" @update:filters="onFiltersUpdate"
      item-key="id_cerca"
      show-select
      v-model="selecionadas"
      cod-tabela="CERCAS" @update:headers="headers = $event">
      <template v-slot:toolbar>
        
        <CadastroToolbar :title="$t('geofence.title')" :token="token" :items="[]"
          :load-items-for-export="loadItemsForExport" background-export
          :export-filters="searchFilters" :export-sort-by="serverSortBy" :export-sort-desc="serverSortDesc"
          :export-total="totalCercas" :selected-ids="selectedCercasIds" id-field="id_cerca"
          :csv-title="$tc('geofence.self', 2)" :pdf-title="$tc('geofence.self', 2)" :pdf-headers="headers"
          :pdf-filename="$tc('geofence.self', 2)" hide-search :endpoint-upload-csv="canEdit || canInsert ? '/api/v1.0/processacsvcercas/' : null" @saveBulk="saveBulk"
          :help-dialog-csv-fields="helpCSV" :help-dialog-csv-model="$tc('geofence.self', 2)" :csv-headers="headersCSV">
          <template v-slot:extension>
            <v-row>
              <v-col cols="12" sm="4" md="6">
              <v-switch 
              v-model="mostrarInativos"
              :label="$t('crudVeiculos.showInactive')"
              class="ml-3 mr-4"
              hide-details
            ></v-switch>
            </v-col>
            <v-col cols="12" sm="4" md="6" style="margin-top: 15px">
            <LazySelect
              ref="linhaFiltroSelect"
              get-url="getLinhaslazy"
              text="nome_linha"
              value="id_linha"
              :label="$tc('line.self', 1)"
              class="mr-4"
              style="max-width: 320px;"
              @input="onLinhaFiltroInput"
            />
            </v-col>
            </v-row>        
          </template>

          <template v-slot:add v-if="canInsert">
            <v-tooltip v-if="canInsert" top>
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark small class="mb-2 mr-2" fab v-on="on" @click="startCreateCerca">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('geofence.registerGeofence') }}</span>
            </v-tooltip>
            <ParseKmlDialog />
          </template>

        </CadastroToolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" color="red" @click.stop="deleteItem(item)"
          :disabled="!canDelete">mdi-delete</v-icon
        >
      </template>
    </merus-data-table>
    </recursos-operacionais-split-layout>
  </v-container>
</template>

<script>

import axios from "axios";
import apiController from "@/utils/apiController";
import { GeoCodeApiKey, GeoCodeBaseUrl } from "@/constants";
import { validador } from "@/constants";
import MerusDataTable from "./Tables/MerusDataTable.vue";
import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
import EventBus from "@/utils/eventBus";
import { getScopedClienteIdForCreate, shouldLockClienteOnCreate } from "@/utils/sessionCliente";
import ParseKmlDialog from "./Dialogs/ParseKmlDialog.vue";
import LazySelect from "./Selects/LazySelect.vue";
import RecursosOperacionaisSplitLayout from "./Linhas/RecursosOperacionaisSplitLayout.vue";
import { sameSelection, mergeSelectionWithPage, dropFromSelection, currentPageItem } from "@/utils/tableSelection";
import serverTableMixin from "@/mixins/serverTableMixin";
import {
  buildRequestParams,
  computePageState,
  initSortFromDefault,
  fetchAllServerPagesForExport,
} from "@/utils/serverTablePagination";

export default {
  components: {
    MerusDataTable,
    CadastroToolbar,
    ParseKmlDialog,
    LazySelect,
    RecursosOperacionaisSplitLayout,
},
  mixins: [serverTableMixin],
  data: () => ({
    headers: [],
    totalCercas: 0,
    numberOfRows: 10,
    itemsPerPageLastOption: 1000,
    lastItemsPerPageBeforeTodos: null,
    pageNumber: 1,
    serverSortBy: [],
    serverSortDesc: [],
    searchFilters: {},
    mostrarInativos: false,
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    attribution:
      '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    search: "",
    showConfirmButton: true,

    formValidado: true,
    /** Só aplica rules do drawer de criação após tentativa de salvar. */
    createValidationAttempted: false,
    currentCenter: [-22.951804, -43.21076],
    empresas: [],
    clientes: [],
    idLinhaSelected: null,
    dialog: false,
    pickLocationAtivo: false,
    desenhoPoligonoAtivo: false,
    operacao: 0,
    alarmeEntrada: false,
    alarmeSaida: false,
    alarmeVelocidade: false,
    confirmDialog: false,
    mensagemdialog: "",
    disableModelo: true,
    loadingtable: true,
    user: null,
    token: null,
    erro: null,
    zoom: 14,
    circleRadius: 0,
    polygon: {
      latlngs: [],
      color: "blue",
    },

    mapOptions: {
      zoomSnap: 0.5,
    },
    cercas: [],
    coords: [],
    editedIndex: -1,
    editedItem: {
      id_cerca: null,
      cod_cerca: null,
      nome_cerca: null,
      cod_integracao: null,
      shape: null,
      geojson: null,
      alarme_entrada: null,
      ativa_entrada_extenso: null,
      alarme_saida: null,
      ativa_saida_extenso: null,
      observacoes: null,
      ativa: true,
      ativa_extenso: null,
      endereco: null,
      lat_centro: null,
      lng_centro: null,
      alarme_velocidade: null,
      velocidade_maxima: null,
      is_circular: null,
      raio_mts: null,
      id_empresa: null,
      razao_social: null,
      id_cliente: null,
      nome_cliente: null,
    },
    deletedItem: {
      id_cerca: null,
      cod_cerca: null,
      nome_cerca: null,
      cod_integracao: null,
      shape: null,
      geojson: null,
      alarme_entrada: null,
      ativa_entrada_extenso: null,
      alarme_saida: null,
      ativa_saida_extenso: null,
      observacoes: null,
      ativa: true,
      ativa_extenso: null,
      endereco: null,
      lat_centro: null,
      lng_centro: null,
      alarme_velocidade: null,
      velocidade_maxima: null,
      is_circular: null,
      raio_mts: null,
      id_empresa: null,
      razao_social: null,
      id_cliente: null,
      nome_cliente: null,
    },
    defaultItem: {
      id_cerca: null,
      cod_cerca: null,
      nome_cerca: null,
      cod_integracao: null,
      shape: null,
      geojson: null,
      alarme_entrada: null,
      ativa_entrada_extenso: null,
      alarme_saida: null,
      ativa_saida_extenso: null,
      observacoes: null,
      ativa: true,
      ativa_extenso: null,
      endereco: null,
      lat_centro: null,
      lng_centro: null,
      alarme_velocidade: null,
      velocidade_maxima: null,
      is_circular: null,
      raio_mts: null,
      id_empresa: null,
      razao_social: null,
      id_cliente: null,
      nome_cliente: null,
    },
    mapKey: 0,
    loadingEndereco: false,
    loadingExport: false,
    recursos: [],
    canInsert: false,
    canEdit: false,
    canDelete: false,
    canEditLinha: false,
    linhaSelecionada: null,
    cercaSelecionada: null,
    selecionadas: [],
    parametrosPage: 0,
    initialDetailTab: 0,
    scopedClienteCreateLocked: false,
  }),
  computed: {
    center() {
      return this.$store.getters['config/centerDefault'];
    },
    /** Cerca exibida na página atual do paginador de parâmetros. */
    itemParametrosAtual() {
      return currentPageItem(this.selecionadas, this.parametrosPage);
    },
    parametrosLabel() {
      const item = this.itemParametrosAtual;
      if (!item) return null;
      return [item.cod_cerca, item.nome_cerca].filter(Boolean).join(" — ") || null;
    },
    selectedCercasIds() {
      return (this.selecionadas || [])
        .map((c) => (c && c.id_cerca != null ? c.id_cerca : null))
        .filter((id) => id != null);
    },
    formTitle() {
      return this.editedIndex === -1
        ? this.$t('geofence.registerGeofence')
        : this.$t('geofence.editGeofence');
    },
    isScopedClienteCreateLock() {
      return this.editedIndex === -1 && this.scopedClienteCreateLocked;
    },
    headersCSV() {
      return [
        { text: this.$t('csv.lineNumber'), value: 'line_number', error: 'error_line' },
        { text: this.$t('crudVeiculos.csvHeaders.operacao'), value: "operacao" },
        { text: this.$t('routs.headers.company'), value: "empresa" },
        { text: this.$t('geofence.headers.main.clientCode'), value: "cod_cliente" },
        { text: this.$t('geofence.headers.main.code'), value: "cod_cerca" },
        { text: this.$t('geofence.headers.main.name'), value: "nome_cerca" },
        { text: this.$t('geofence.headers.main.integrationCode'), value: "cod_integracao" },
        { text: this.$t('geofence.headers.main.entranceAlarm'), value: "alarme_entrada" },
        { text: this.$t('geofence.headers.main.exitAlarm'), value: "alarme_saida" },
        { text: this.$t('geofence.headers.main.speedAlarm'), value: "alarme_velocidade" },
        { text: this.$t('geofence.headers.main.maxSpeed'), value: "velocidade_maxima" },
        { text: this.$t('geofence.headers.main.geojson'), value: "geojson" },
        { text: this.$t('geofence.headers.main.is_circular'), value: "is_circular" },
        { text: this.$t('geofence.headers.main.raio_mts'), value: "raio_mts" },
        { text: this.$t('geofence.headers.main.observacoes'), value: "observacoes" },
        { text: this.$t('geofence.headers.main.lat_centro'), value: "lat_centro" },
        { text: this.$t('geofence.headers.main.lng_centro'), value: "lng_centro" },
        { text: this.$t('geofence.headers.main.endereco'), value: "endereco" },
        { text: this.$t('geofence.headers.main.ativa'), value: "ativa" }];
    },
    helpCSV() {
      return [
        {
          label: this.$t('routs.headers.company'),
          description: this.$t('geofence.headers.main.csvEmpresaDescription'),
          example: this.$t('csv.fields.companyCode.example'),
          key: "empresa"
        },
        {
          label: this.$t('geofence.headers.main.clientCode'),
          description: this.$t('geofence.headers.main.clientCodeDescription'),
          example: this.$t('geofence.headers.main.clientCodeExample'),
          key: "cod_cliente"
        },
        {
          label: this.$t('geofence.headers.main.code'),
          description: this.$t('geofence.headers.main.codeDescription'),
          example: this.$t('geofence.headers.main.codeExample'),
          key: "cod_cerca"
        },
        {
          label: this.$t('geofence.headers.main.name'),
          description: this.$t('geofence.headers.main.nameDescription'),
          example: this.$t('geofence.headers.main.nameExample'),
          key: "nome_cerca"
        },
        {
          label: this.$t('geofence.headers.main.integrationCode'),
          description: this.$t('geofence.headers.main.integrationCodeDescription'),
          example: this.$t('geofence.headers.main.integrationCodeExample'),
          key: "cod_integracao"
        },
        {
          label: this.$t('geofence.headers.main.entranceAlarm'),
          description: this.$t('geofence.headers.main.entranceAlarmDescription'),
          example: this.$t('geofence.headers.main.entranceAlarmExample'),
          key: "alarme_entrada"
        },
        {
          label: this.$t('geofence.headers.main.exitAlarm'),
          description: this.$t('geofence.headers.main.exitAlarmDescription'),
          example: this.$t('geofence.headers.main.exitAlarmExample'),
          key: "alarme_saida"
        },
        {
          label: this.$t('geofence.headers.main.speedAlarm'),
          description: this.$t('geofence.headers.main.speedAlarmDescription'),
          example: this.$t('geofence.headers.main.speedAlarmExample'),
          key: "alarme_velocidade"
        },
        {
          label: this.$t('geofence.headers.main.maxSpeed'),
          description: this.$t('geofence.headers.main.maxSpeedDescription'),
          example: this.$t('geofence.headers.main.maxSpeedExample'),
          key: "velocidade_maxima"
        },
        {
          label: this.$t('geofence.headers.main.geojson'),
          description: this.$t('geofence.headers.main.geojsonDescription'),
          example: this.$t('geofence.headers.main.geojsonExample'),
          key: "geojson"
        },
        {
          label: this.$t('geofence.headers.main.is_circular'),
          description: this.$t('geofence.headers.main.is_circularDescription'),
          example: this.$t('geofence.headers.main.is_circularExample'),
          key: "is_circular"
        },
        {
          label: this.$t('geofence.headers.main.raio_mts'),
          description: this.$t('geofence.headers.main.raio_mtsDescription'),
          example: this.$t('geofence.headers.main.raio_mtsExample'),
          key: "raio_mts"
        },
        {
          label: this.$t('geofence.headers.main.observacoes'),
          description: this.$t('geofence.headers.main.observacoesDescription'),
          example: this.$t('geofence.headers.main.observacoesExample'),
          key: "observacoes"
        },
        {
          label: this.$t('geofence.headers.main.lat_centro'),
          description: this.$t('geofence.headers.main.lat_centroDescription'),
          example: this.$t('geofence.headers.main.lat_centroExample'),
          key: "lat_centro"
        },
        {
          label: this.$t('geofence.headers.main.lng_centro'),
          description: this.$t('geofence.headers.main.lng_centroDescription'),
          example: this.$t('geofence.headers.main.lng_centroExample'),
          key: "lng_centro"
        },
        {
          label: this.$t('geofence.headers.main.endereco'),
          description: this.$t('geofence.headers.main.enderecoDescription'),
          example: this.$t('geofence.headers.main.enderecoExample'),
          key: "endereco"
        },
        {
          label: this.$t('geofence.headers.main.ativa'),
          description: this.$t('geofence.headers.main.ativaDescription'),
          example: this.$t('geofence.headers.main.ativaExample'),
          key: "ativa"
        }];
    },
    defaultSort() {
      return [
        { value: 'cod_cerca', options: { text: this.$t('routs.increasing'), value: 1 } }];
    },
    messageConfirmButton() {
      return this.$t('button.confirm');
    },
    messageDismissButton() {
      return this.$t('button.dismiss');
    },
    contagemVerticesPoligono() {
      const shape = this.editedItem && this.editedItem.shape;
      if (!shape) return 0;
      try {
        const arr = typeof shape === "string" ? JSON.parse(shape) : shape;
        if (!Array.isArray(arr) || !arr.length) return 0;
        let n = arr.length;
        if (n >= 2) {
          const a = arr[0];
          const b = arr[n - 1];
          const aLat = a && (a.lt != null ? a.lt : a.lat);
          const aLng = a && (a.lg != null ? a.lg : a.lng);
          const bLat = b && (b.lt != null ? b.lt : b.lat);
          const bLng = b && (b.lg != null ? b.lg : b.lng);
          if (Number(aLat) === Number(bLat) && Number(aLng) === Number(bLng)) n -= 1;
        }
        return Math.max(0, n);
      } catch (e) {
        return 0;
      }
    },
    formatoCercaRules() {
      if (this.editedItem.is_circular == null || this.editedItem.is_circular === "") {
        return this.$t("geofence.formatRequired");
      }
      return true;
    },
    codCercaRules() {
      if (!validador(this.editedItem.cod_cerca, 1, 50, 0, 1)) {
        return this.$t('geofence.invalidCode');
      } else {
        return true;
      }
    },
    nomeCercaRules() {
      if (!validador(this.editedItem.nome_cerca, 1, 200, 1, 1)) {
        return this.$t('geofence.invalidName');
      } else {
        return true;
      }
    },
    codIntegracaoRules() {
      const valor = this.editedItem.cod_integracao;
      if (valor === null || valor === undefined || String(valor).length === 0) {
        return true;
      }
      if (!validador(valor, 1, 50, 0, 1)) {
        return this.$t('geofence.invalidIntegrationCode');
      }
      return true;
    },
    observacoesRules() {
      // if (!validador(this.editedItem.observacoes, 1, 10000, 1, 0)) {
      //   return "Observações deve conter somente letras, números, ( _ - . , )";
      // } else {
      //   return true;
      // }
      return (this.editedItem.observacoes === null || this.editedItem.observacoes.length <= 1000) || this.$t('geofence.invalidObservations');
    },
    velocidadeRules() {
      if (this.alarmeVelocidade && !this.editedItem.velocidade_maxima) {
        return this.$t('geofence.invalidSpeed');
      }

      return true;
    },
    clientesFiltrados() {
      if (!this.editedItem.id_empresa) {
        return [];
      }
      return this.clientes.filter(
        (c) => c.id_empresa === this.editedItem.id_empresa && (c.ativo === 1 || c.ativo === true)
      );
    },
  },
  watch: {
    selecionadas(list, prev) {
      // MerusDataTable emite `input` duas vezes por mudança: compara por chave.
      if (sameSelection(list, prev, "id_cerca")) return;
      this.parametrosPage = 0;
    },
    itemParametrosAtual(item, prev) {
      const atual = item && item.id_cerca;
      const anterior = prev && prev.id_cerca;
      if (String(atual) === String(anterior)) return;
      this.selecionarCerca(item || null);
    },
    mostrarInativos() {
      this.searchFilters = Object.assign({}, this.serverTableBaseFilters(), this.columnFiltersOnly());
      this.pageNumber = 1;
      this.serverTableLoad();
    },
    idLinhaSelected() {
      this.searchFilters = Object.assign({}, this.serverTableBaseFilters(), this.columnFiltersOnly());
      this.pageNumber = 1;
      this.serverTableLoad();
    },
    dialog(val) {
      if (val && this.editedIndex === -1) {
        this.$nextTick(() => {
          this.applyScopedClienteEmpresaOnCreate();
          this.applySingleEmpresaIfOnlyOption();
        });
      }
      val || this.close();
    },
    clientes() {
      if (this.dialog && this.editedIndex === -1) {
        this.applyScopedClienteEmpresaOnCreate();
        this.applySingleEmpresaIfOnlyOption();
      }
    },
    empresas() {
      if (this.dialog && this.editedIndex === -1) {
        this.$nextTick(() => {
          this.applyScopedClienteEmpresaOnCreate();
          this.applySingleEmpresaIfOnlyOption();
        });
      }
    },
    '$i18n.locale'() {
      this.initialize();
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    'editedItem.id_empresa'() {
      if (this.editedItem.id_cliente == null) {
        return;
      }
      const ok = this.clientesFiltrados.some((c) => c.id_cliente === this.editedItem.id_cliente);
      if (!ok) {
        this.editedItem.id_cliente = null;
      }
    },
    'editedItem.id_cliente'(id) {
      if (id == null) {
        return;
      }
      const c = this.clientes.find((x) => x.id_cliente === id);
      if (c && c.id_empresa != null) {
        this.editedItem.id_empresa = c.id_empresa;
      }
    },
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.populaRecursos();
  },
  mounted() { },
  methods: {
    onLinhaFiltroInput(val) {
      this.idLinhaSelected = val;
    },
    columnFiltersOnly() {
      const baseKeys = { somente_ativas: true, id_linha: true };
      const out = {};
      Object.keys(this.searchFilters || {}).forEach((k) => {
        if (!baseKeys[k]) out[k] = this.searchFilters[k];
      });
      return out;
    },
    serverTableBaseFilters() {
      const base = {};
      if (!this.mostrarInativos) base.somente_ativas = '1';
      if (this.idLinhaSelected) base.id_linha = String(this.idLinhaSelected);
      return base;
    },
    selecionarCerca(item) {
      this.cercaSelecionada = item || null;
      if (!item) {
        this.linhaSelecionada = null;
        return;
      }
      this.loadParametrosCerca(item);
      this.initialDetailTab = 0;
      this.linhaSelecionada = null;
    },
    loadParametrosCerca(item) {
      if (this.dialog) return;
      this.scopedClienteCreateLocked = false;
      this.editedIndex = item && item.id_cerca != null ? 0 : -1;
      this.editedItem = Object.assign({}, item);
      // Normaliza 0/1 para o seletor de formato (API pode devolver string/boolean).
      const circular = Number(this.editedItem.is_circular) === 1;
      this.$set(this.editedItem, "is_circular", circular ? 1 : 0);
      this.alarmeEntrada = Number(this.editedItem.alarme_entrada) === 1;
      this.alarmeSaida = Number(this.editedItem.alarme_saida) === 1;
      this.alarmeVelocidade = Number(this.editedItem.alarme_velocidade) === 1;
      this.parseShape(this.editedItem.shape);
    },
    saveParametros() {
      if (this.dialog || this.editedItem.id_cerca == null) return;
      this.save();
    },
    async resolveLinhaFromCerca(cerca) {
      try {
        const res = await apiController.request(apiController.endpoints.getLinhasbycerca, {
          params: { idCerca: cerca.id_cerca },
          silent: true,
        });
        const linhas = Array.isArray(res.data) ? res.data : [];
        if (!linhas.length) return null;
        if (this.idLinhaSelected != null) {
          const filtered = linhas.find(
            (l) => Number(l.id_linha) === Number(this.idLinhaSelected)
          );
          if (filtered) return { ...filtered };
        }
        return { ...linhas[0] };
      } catch (e) {
        EventBus.$emit("show-error", { error: e });
        return null;
      }
    },
    populaRecursos() {
      if (this.user.is_superadmin === 1) {
        apiController.request(apiController.endpoints.getallRecursos, {
          onSuccess: (response) => {
            this.recursos = response.data;
            this.canEdit = true;
            this.canInsert = true;
            this.canDelete = true;
            this.canEditLinha = true;
            this.initialize();
          },
        });
      } else {
        apiController.request(apiController.endpoints.getRecursosusuario, {
          params: { id: this.user.id_usuario },
          onSuccess: (response) => {
            this.recursos = response.data;
            this.canEdit = this.recursos.some((r) => r.rota === "/api/v1.0/updatecerca");
            this.canInsert = this.recursos.some((r) => r.rota === "/api/v1.0/insertcerca");
            this.canDelete = this.recursos.some((r) => r.rota === "/api/v1.0/deletecerca");
            this.canEditLinha = this.recursos.some((r) => r.rota === "/api/v1.0/updatelinha");
            this.initialize();
          },
        });
      }
    },
    /** Reaponta a seleção para os objetos da página sem perder marcados em outras páginas. */
    resyncAposReload() {
      this.selecionadas = mergeSelectionWithPage(this.selecionadas, this.cercas, "id_cerca");
      const item = this.itemParametrosAtual;
      if (item) {
        this.cercaSelecionada = item;
        this.loadParametrosCerca(item);
      }
    },
    /** Ações do menu de controles do mapa no contexto "cercas". */
    onMapAction({ action, lat, lng, active, geometry } = {}) {
      if (action === "create-fence") {
        this.startCreateCerca();
        return;
      }
      if (action === "close-create") {
        this.close({ fromMap: true });
        return;
      }
      if (action === "pick-location-mode") {
        this.pickLocationAtivo = !!active;
        return;
      }
      if (action === "pick-location") {
        this.aplicarLocalizacaoDoMapa(lat, lng);
        return;
      }
      if (action === "draw-polygon-mode") {
        this.desenhoPoligonoAtivo = !!active;
        return;
      }
      if (action === "fence-polygon-draft") {
        this.aplicarGeometriaDoMapa(geometry, { preview: false });
        return;
      }
      if (action === "fence-polygon-drawn" || action === "fence-geometry-changed") {
        this.aplicarGeometriaDoMapa(geometry);
      }
    },
    aplicarGeometriaDoMapa(geometry, { preview = true } = {}) {
      if (!geometry || typeof geometry !== "object") return;
      const shape =
        geometry.shape == null
          ? null
          : typeof geometry.shape === "string"
            ? geometry.shape
            : JSON.stringify(geometry.shape);
      const geojson =
        geometry.geojson == null
          ? null
          : typeof geometry.geojson === "string"
            ? geometry.geojson
            : JSON.stringify(geometry.geojson);
      this.$set(this.editedItem, "shape", shape);
      this.$set(this.editedItem, "geojson", geojson);
      this.$set(
        this.editedItem,
        "is_circular",
        geometry.is_circular != null ? Number(geometry.is_circular) : this.editedItem.is_circular,
      );
      this.$set(
        this.editedItem,
        "raio_mts",
        geometry.raio_mts != null ? geometry.raio_mts : this.editedItem.raio_mts,
      );
      if (geometry.lat_centro != null) this.$set(this.editedItem, "lat_centro", geometry.lat_centro);
      if (geometry.lng_centro != null) this.$set(this.editedItem, "lng_centro", geometry.lng_centro);
      this.parseShape(this.editedItem.shape);
      if (preview) {
        this.previewCercaNoMapa(null, { focus: false });
      }
    },
    toggleDesenhoPoligono() {
      const split = this.$refs.detalheSplit;
      const next = !this.desenhoPoligonoAtivo;
      if (split && typeof split.setDrawPolygonMode === "function") {
        split.setDrawPolygonMode(next);
      }
    },
    limparPoligonoFormulario() {
      this.$set(this.editedItem, "shape", null);
      this.$set(this.editedItem, "geojson", null);
      this.polygon.latlngs = [];
      this.previewCercaNoMapa(null, { focus: false });
    },
    /**
     * Prepara o formulário de criação no drawer do mapa.
     */
    startCreateCerca() {
      this.scopedClienteCreateLocked = false;
      this.editedIndex = -1;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.alarmeEntrada = false;
      this.alarmeSaida = false;
      this.alarmeVelocidade = false;
      this.createValidationAttempted = false;
      this.dialog = true;
      this.$nextTick(() => {
        const form = this.$refs.formCreate || this.$refs.form;
        if (form && typeof form.resetValidation === "function") {
          form.resetValidation();
        }
        const split = this.$refs.detalheSplit;
        if (split && typeof split.openCreateDrawer === "function") {
          split.openCreateDrawer({ silent: true });
        }
      });
    },
    previewCercaNoMapa(cerca, opts) {
      const split = this.$refs.detalheSplit;
      if (split && typeof split.previewAndFocusCerca === "function") {
        split.previewAndFocusCerca(cerca || this.editedItem, opts);
      }
    },
    aplicarLocalizacaoDoMapa(lat, lng) {
      if (!this.isLatitude(lat) || !this.isLongitude(lng)) return;
      this.editedItem.lat_centro = Number(Number(lat).toFixed(6));
      this.editedItem.lng_centro = Number(Number(lng).toFixed(6));
      this.currentCenter = [this.editedItem.lat_centro, this.editedItem.lng_centro];
      this.previewCercaNoMapa(null, { focus: false });
    },
    togglePickLocation() {
      const split = this.$refs.detalheSplit;
      if (split && typeof split.setPickLocationMode === "function") {
        split.setPickLocationMode(!this.pickLocationAtivo);
      }
    },
    /** Cerca reposicionada por arrasto no mapa de preview. */
    onPreviewChanged({ item } = {}) {
      if (!item || item.id_cerca == null) return;
      const row = this.cercas.find((c) => Number(c.id_cerca) === Number(item.id_cerca));
      if (row) Object.assign(row, item);
      // Evita reatribuir cercaSelecionada com objeto novo quando a identidade não mudou
      // (isso dispararia syncEntityPreview e apagaria camadas recém-montadas).
      if (
        this.cercaSelecionada &&
        Number(this.cercaSelecionada.id_cerca) === Number(item.id_cerca)
      ) {
        Object.assign(this.cercaSelecionada, item);
        if (
          this.editedItem &&
          Number(this.editedItem.id_cerca) === Number(item.id_cerca)
        ) {
          this.$set(this.editedItem, "raio_mts", item.raio_mts);
          this.$set(this.editedItem, "lat_centro", item.lat_centro);
          this.$set(this.editedItem, "lng_centro", item.lng_centro);
          this.$set(this.editedItem, "geojson", item.geojson);
          this.$set(this.editedItem, "shape", item.shape);
          this.$set(this.editedItem, "is_circular", item.is_circular);
          this.circleRadius = item.raio_mts;
        }
        return;
      }
      this.resyncAposReload();
    },
    initialize() {
      if (this.serverSortBy.length === 0 && this.defaultSort && this.defaultSort.length > 0) {
        const { serverSortBy, serverSortDesc } = initSortFromDefault(this.defaultSort);
        this.serverSortBy = serverSortBy;
        this.serverSortDesc = serverSortDesc;
      }
      this.searchFilters = Object.assign({}, this.serverTableBaseFilters(), this.columnFiltersOnly());
      this.serverTableLoad();
      this.populaEmpresas();
      this.populaClientes();
    },
    serverTableLoad(options) {
      const state = {
        pageNumber: this.pageNumber,
        numberOfRows: this.numberOfRows,
        serverSortBy: this.serverSortBy,
        serverSortDesc: this.serverSortDesc,
        searchFilters: this.searchFilters,
        lastItemsPerPageBeforeTodos: this.lastItemsPerPageBeforeTodos,
        total: this.totalCercas,
      };
      const { params, page, rowsPerPage, sortByArr, sortDescArr } = buildRequestParams(options, state);
      this.loadingtable = true;
      apiController.request(apiController.endpoints.getallCercas, {
        data: params,
        onSuccess: (response) => {
          const data = response.data;
          const totalNum = data && data.total != null && data.total !== '' ? Number(data.total) : NaN;
          if (data && !Number.isNaN(totalNum) && Array.isArray(data.items)) {
            this.cercas = data.items;
            const updates = computePageState(
              { items: data.items, total: totalNum },
              { page, rowsPerPage, sortByArr, sortDescArr },
              state,
              this.itemsPerPageLastOption
            );
            this.totalCercas = updates.total;
            this.pageNumber = updates.pageNumber;
            this.numberOfRows = updates.numberOfRows;
            this.lastItemsPerPageBeforeTodos = updates.lastItemsPerPageBeforeTodos;
            this.serverSortBy = updates.serverSortBy;
            this.serverSortDesc = updates.serverSortDesc;
          } else {
            this.cercas = Array.isArray(data) ? data : [];
            this.totalCercas = this.cercas.length;
          }
          this.loadingtable = false;
          this.$nextTick(() => this.resyncAposReload());
        },
        onError: () => {
          this.loadingtable = false;
        },
      });
    },
    mapForExport(rows) {
      return (rows || []).map((cerca) => ({
        ...cerca,
        empresa: cerca.empresa || "",
        codigo_cliente: cerca.codigo_cliente != null && cerca.codigo_cliente !== ""
          ? cerca.codigo_cliente
          : (cerca.cliente_codigo || ""),
        geojson: this.compactExportJsonField(cerca.geojson),
      }));
    },
    async loadItemsForExport(onProgress) {
      const selected = this.selecionadas;
      if (selected && selected.length > 0) {
        if (typeof onProgress === "function") onProgress(100);
        return this.mapForExport(selected.slice());
      }
      return fetchAllServerPagesForExport({
        fetchPage: async (params) => {
          const response = await apiController.request(
            apiController.endpoints.getallCercas,
            { data: params, silent: true },
          );
          return response && response.data;
        },
        state: {
          total: this.totalCercas,
          serverSortBy: this.serverSortBy,
          serverSortDesc: this.serverSortDesc,
          searchFilters: this.searchFilters,
        },
        mapItems: (items) => this.mapForExport(items),
        onProgress,
      });
    },
    populaEmpresas() {
      apiController.request(apiController.endpoints.getallEmpresas, {
        onSuccess: (response) => {
          this.empresas = response.data || [];
        },
      });
    },
    populaClientes() {
      apiController.request(apiController.endpoints.getallClientes, {
        onSuccess: (response) => {
          this.clientes = (response.data || []).map((c) => ({
            ...c,
            labelCliente: [c.codigo_cliente, c.nome_cliente].filter(Boolean).join(" — "),
          }));
        },
      });
    },
    applyScopedClienteEmpresaOnCreate() {
      this.scopedClienteCreateLocked = false;
      if (this.editedIndex !== -1 || !shouldLockClienteOnCreate()) {
        return;
      }
      const id = getScopedClienteIdForCreate();
      if (id == null) {
        return;
      }
      const c = this.clientes.find((x) => Number(x.id_cliente) === Number(id));
      if (!c || c.id_empresa == null) {
        return;
      }
      this.editedItem.id_cliente = id;
      this.editedItem.id_empresa = c.id_empresa;
      this.scopedClienteCreateLocked = true;
    },
    applySingleEmpresaIfOnlyOption() {
      if (!this.dialog || this.editedIndex !== -1) {
        return;
      }
      if (this.scopedClienteCreateLocked) {
        return;
      }
      if (this.editedItem.id_empresa != null && this.editedItem.id_empresa !== '') {
        return;
      }
      if (!Array.isArray(this.empresas) || this.empresas.length !== 1) {
        return;
      }
      this.editedItem.id_empresa = this.empresas[0].id_empresa;
    },
    editItem(item) {
      this.loadParametrosCerca(item);
      this.cercaSelecionada = item;
      const split = this.$refs.detalheSplit;
      if (split && typeof split.abrirAbaParametros === "function") {
        split.abrirAbaParametros();
      }
    },
    deleteItem(item) {
      this.deletedItem = Object.assign({}, item);
      this.mensagemdialog =
        this.$t('geofence.confirmDelete', { geofence: item.cod_cerca });
      this.showConfirmButton = true;
      this.messageDismissButton = this.$t('button.dismiss');
      this.messageConfirmButton = this.$t('button.confirm');
      this.confirmDialog = true;
    },
    parseShape(shape) {
      if (this.editedItem.is_circular == 1) {
        if (this.editedItem.lat_centro != null && this.editedItem.lng_centro != null) {
          this.circleCenter = [this.editedItem.lat_centro, this.editedItem.lng_centro];
        } else {
          this.circleCenter = [-22.951804, -43.21076];
        }
        this.circleRadius = this.editedItem.raio_mts || 200;
        this.currentCenter = this.circleCenter;
        return;
      }

      var coords = [];
      if (shape == "" || shape == null) {
        this.currentCenter = [-22.951804, -43.21076];
        this.polygon.latlngs = [];
        return;
      }
      try {
        const array = typeof shape === "string" ? JSON.parse(shape) : shape;
        if (Array.isArray(array) && array.length > 0) {
          for (var i = 0; i < array.length; i++) {
            coords.push({ lng: array[i].lg, lat: array[i].lt });
          }
        }
      } catch (e) {
        this.polygon.latlngs = [];
        return;
      }
      this.polygon.latlngs = coords;
      if (!this.polygon.latlngs.length) {
        this.currentCenter = [-22.951804, -43.21076];
        return;
      }
      const centro = Math.floor(this.polygon.latlngs.length / 2);
      this.currentCenter = [
        this.polygon.latlngs[centro].lat,
        this.polygon.latlngs[centro].lng];
    },
    isLatitude(lat) {
      return lat != "" && isFinite(lat) && Math.abs(lat) <= 90;
    },
    isLongitude(lng) {
      return lng != "" && isFinite(lng) && Math.abs(lng) <= 180;
    },
    raioRules() {
      if (this.editedItem.is_circular == 1) {
        if (this.editedItem.raio_mts == null) {
          return this.$t('geofence.radiusRequired');
        } else {
          if (this.editedItem.raio_mts <= 0) {
            return this.$t('geofence.radiusMustBeGreaterThanZero');
          } else {
            return true;
          }
        }
      } else {
        return true;
      }
    },
    circularChanged() {
      const circular = this.editedItem.is_circular == 1 || this.editedItem.is_circular === true;
      this.editedItem.is_circular = circular ? 1 : 0;
      if (circular) {
        if (!this.editedItem.raio_mts || Number(this.editedItem.raio_mts) <= 0) {
          this.editedItem.raio_mts = 50;
        }
        this.circleRadius = this.editedItem.raio_mts;
        this.$set(this.editedItem, "shape", null);
        this.$set(this.editedItem, "geojson", null);
        this.polygon.latlngs = [];
        const split = this.$refs.detalheSplit;
        if (split && typeof split.setDrawPolygonMode === "function") {
          split.setDrawPolygonMode(false);
        }
        this.desenhoPoligonoAtivo = false;
      } else {
        this.editedItem.raio_mts = 0;
        this.circleRadius = 0;
        const split = this.$refs.detalheSplit;
        if (split && typeof split.setPickLocationMode === "function") {
          split.setPickLocationMode(false);
        }
        this.pickLocationAtivo = false;
        // Sem polígono ainda: abre desenho no mapa para definir o formato.
        const shape = this.editedItem.shape;
        const empty =
          shape == null ||
          shape === "" ||
          (typeof shape === "string" && shape.trim() === "[]");
        if (empty && split && typeof split.setDrawPolygonMode === "function") {
          split.setDrawPolygonMode(true);
          this.desenhoPoligonoAtivo = true;
        }
      }
      this.parseShape(this.editedItem.shape);
      if (
        this.cercaSelecionada &&
        this.editedItem.id_cerca != null &&
        Number(this.cercaSelecionada.id_cerca) === Number(this.editedItem.id_cerca)
      ) {
        this.$set(this.cercaSelecionada, "is_circular", this.editedItem.is_circular);
        this.$set(this.cercaSelecionada, "raio_mts", this.editedItem.raio_mts);
        this.$set(this.cercaSelecionada, "shape", this.editedItem.shape);
        this.$set(this.cercaSelecionada, "geojson", this.editedItem.geojson);
      }
      this.previewCercaNoMapa(null, { focus: false });
    },
    deleteFromDatabase() {
      this.operacao = 2;
      this.confirmDialog = false;
      const deletedId = this.deletedItem && this.deletedItem.id_cerca;
      apiController.request(apiController.endpoints.deleteCerca, {
        data: this.deletedItem,
        onSuccess: (response) => {
          if (deletedId != null) {
            this.selecionadas = dropFromSelection(this.selecionadas, [deletedId], "id_cerca");
          }
          this.updateTable(response.data.erro);
        },
      });
    },
    close({ fromMap } = {}) {
      this.dialog = false;
      const split = this.$refs.detalheSplit;
      if (!fromMap && split && typeof split.closeCreateDrawer === "function") {
        split.closeCreateDrawer({ silent: true });
      }
      if (split && typeof split.setPickLocationMode === "function") {
        split.setPickLocationMode(false);
      }
      if (split && typeof split.setDrawPolygonMode === "function") {
        split.setDrawPolygonMode(false);
      }
      if (split && typeof split.clearCreateDraft === "function") {
        split.clearCreateDraft();
      }
      this.$nextTick(() => {
        this.scopedClienteCreateLocked = false;
        this.pickLocationAtivo = false;
        this.desenhoPoligonoAtivo = false;
        this.createValidationAttempted = false;
        this.editedItem = Object.assign({}, this.defaultItem);
        this.deletedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.alarmeEntrada = false;
        this.alarmeSaida = false;
        this.alarmeVelocidade = false;
        this.currentCenter = this.center;
        this.polygon.latlngs = [];
        this.circleCenter = this.currentCenter;
        this.circleRadius = 0;
        const form = this.$refs.formCreate || this.$refs.form;
        if (form && typeof form.resetValidation === "function") {
          form.resetValidation();
        }
        const item = this.itemParametrosAtual;
        if (item) this.loadParametrosCerca(item);
      });
    },
    save() {
      if (this.dialog) {
        this.createValidationAttempted = true;
      }
      const form = this.dialog
        ? (this.$refs.formCreate || this.$refs.form)
        : (this.$refs.formParametros || this.$refs.form);
      const runSave = () => {
        const valid = form ? form.validate() : this.formValidado;
        if (!valid) return;

        if (
          this.editedItem.is_circular == null ||
          this.editedItem.is_circular === ""
        ) {
          EventBus.$emit("show-alert", {
            mensagem: this.$t("geofence.formatRequired"),
            tipo: "error",
          });
          return;
        }
        const circular =
          this.editedItem.is_circular == 1 || this.editedItem.is_circular === true;
        this.editedItem.is_circular = circular ? 1 : 0;

        if (circular) {
          const raio = Number(this.editedItem.raio_mts);
          if (
            !Number.isFinite(raio) ||
            raio <= 0 ||
            !this.isLatitude(this.editedItem.lat_centro) ||
            !this.isLongitude(this.editedItem.lng_centro)
          ) {
            EventBus.$emit("show-alert", {
              mensagem: this.$t("geofence.circularGeometryRequired"),
              tipo: "error",
            });
            return;
          }
          this.editedItem.shape = null;
        } else {
          const shape = this.editedItem.shape;
          const empty =
            shape == null ||
            shape === "" ||
            (typeof shape === "string" && shape.trim() === "[]");
          if (empty) {
            EventBus.$emit("show-alert", {
              mensagem: this.$t("geofence.shapeRequired"),
              tipo: "error",
            });
            return;
          }
        }

        if (this.alarmeEntrada) {
          this.editedItem.alarme_entrada = 1;
        } else {
          this.editedItem.alarme_entrada = 0;
        }

        if (this.alarmeSaida) {
          this.editedItem.alarme_saida = 1;
        } else {
          this.editedItem.alarme_saida = 0;
        }

        if (this.alarmeVelocidade) {
          this.editedItem.alarme_velocidade = 1;
        } else {
          this.editedItem.alarme_velocidade = 0;
        }

        if (this.editedItem.geojson != null && typeof this.editedItem.geojson !== "string") {
          this.editedItem.geojson = JSON.stringify(this.editedItem.geojson);
        }
        if (this.editedItem.shape != null && typeof this.editedItem.shape !== "string") {
          this.editedItem.shape = JSON.stringify(this.editedItem.shape);
        }
        this.editedItem.cod_integracao =
          this.editedItem.cod_integracao != null
            && String(this.editedItem.cod_integracao).trim() !== ""
            ? String(this.editedItem.cod_integracao).trim()
            : null;

        const isNovo = this.editedItem.id_cerca == null || this.editedItem.id_cerca === undefined;
        if (isNovo) {
          this.operacao = 0;
          apiController.request(apiController.endpoints.insertCerca, {
            data: this.editedItem,
            onSuccess: (response) => {
              this.updateTable(response.data.erro);
            },
          });
        } else {
          this.operacao = 1;
          apiController.request(apiController.endpoints.updateCerca, {
            data: this.editedItem,
            onSuccess: (response) => {
              this.updateTable(response.data.erro);
            },
          });
        }
        this.currentCenter = this.center;
      };

      // Confirma polígono ainda em desenho e aplica no formulário antes de validar.
      const split = this.$refs.detalheSplit;
      if (split && typeof split.finalizeDrawFenceIfPending === "function") {
        split.finalizeDrawFenceIfPending();
      }

      // Aguarda as rules do drawer de criação (e o sync do polígono) entrarem no DOM.
      if (this.dialog) {
        this.$nextTick(runSave);
      } else {
        runSave();
      }
    },
    updateTable(status) {
      if (status) {
        if (this.operacao == 0) {
          EventBus.$emit('show-alert', { mensagem: this.$t('geofence.updateTable.error.insert'), tipo: 'error' });
        } else {
          if (this.operacao == 1) {
            EventBus.$emit('show-alert', { mensagem: this.$t('geofence.updateTable.error.update'), tipo: 'error' });
          } else {
            EventBus.$emit('show-alert', { mensagem: this.$t('geofence.updateTable.error.delete'), tipo: 'error' });
          }
        }
      } else {
        if (this.operacao == 0) {
          EventBus.$emit('show-alert', { mensagem: this.$t('geofence.updateTable.success.insert'), tipo: 'success' });
        } else {
          if (this.operacao == 1) {
            EventBus.$emit('show-alert', { mensagem: this.$t('geofence.updateTable.success.update'), tipo: 'success' });
          } else {
            EventBus.$emit('show-alert', { mensagem: this.$t('geofence.updateTable.success.delete'), tipo: 'success' });
          }
        }
      }
      this.close();
      const idLinhaFiltro = this.idLinhaSelected;
      this.searchFilters = Object.assign({}, this.serverTableBaseFilters(), this.columnFiltersOnly());
      this.serverTableLoad();
      if (idLinhaFiltro) {
        this.$nextTick(() => {
          if (this.$refs.linhaFiltroSelect && typeof this.$refs.linhaFiltroSelect.setData === 'function') {
            this.$refs.linhaFiltroSelect.setData(idLinhaFiltro);
          }
        });
      }
    },
    getMarkerFromEndereco() {
      if (this.editedItem.endereco) {
        this.loadingEndereco = true;
        axios
          .get(GeoCodeBaseUrl +
            encodeURIComponent(this.editedItem.endereco) +
            "&limit=1&types=address" +
            "&access_token=" + GeoCodeApiKey)
          .then((response) => {
            this.editedItem.lat_centro = response.data.features[0].properties.coordinates.latitude;
            this.editedItem.lng_centro = response.data.features[0].properties.coordinates.longitude;
            this.editedItem.shape = null;
            this.currentCenter = [this.editedItem.lat_centro, this.editedItem.lng_centro];
            this.previewCercaNoMapa();
            this.loadingEndereco = false;
          })
          .catch((e) => {
            this.loadingEndereco = false;
            EventBus.$emit('show-error', { error: e });
        });
      }
    },
    getMarkerFromLatLong() {
      if (this.editedItem.lat_centro && this.editedItem.lng_centro) {
        const lat = Number(this.editedItem.lat_centro);
        const lng = Number(this.editedItem.lng_centro);
        this.currentCenter = [lat, lng];
        this.previewCercaNoMapa();
      }
    },
    compactExportJsonField(value) {
      if (!value) {
        return value;
      }
      try {
        return JSON.stringify(typeof value === "string" ? JSON.parse(value) : value);
      } catch (e) {
        return String(value).replace(/\r?\n|\r/g, " ");
      }
    },
    saveBulk(result) {
      apiController.request(apiController.endpoints.insertCercasbulk, {
        data: result,
        onSuccess: (response) => {
          this.updateTable(response.data.erro);
        },
      });
    },
    radiusChanged() {
      const raio = Number(this.editedItem.raio_mts);
      this.circleRadius = Number.isFinite(raio) ? raio : this.editedItem.raio_mts;
      if (this.editedItem.is_circular == 1) {
        const lat = Number(this.editedItem.lat_centro);
        const lng = Number(this.editedItem.lng_centro);
        if (Number.isFinite(lat) && Number.isFinite(lng)) {
          this.$set(
            this.editedItem,
            "geojson",
            JSON.stringify({ type: "Point", coordinates: [lng, lat] }),
          );
          this.$set(this.editedItem, "shape", null);
        }
      }
      // Mantém o item de preview alinhado sem trocar a identidade do objeto
      // (reatribuir cercaSelecionada dispara syncEntityPreview e remonta camadas).
      if (
        this.cercaSelecionada &&
        this.editedItem.id_cerca != null &&
        Number(this.cercaSelecionada.id_cerca) === Number(this.editedItem.id_cerca)
      ) {
        this.$set(this.cercaSelecionada, "raio_mts", this.editedItem.raio_mts);
        this.$set(this.cercaSelecionada, "geojson", this.editedItem.geojson);
        this.$set(this.cercaSelecionada, "shape", this.editedItem.shape);
        this.$set(this.cercaSelecionada, "is_circular", this.editedItem.is_circular);
      }
      this.previewCercaNoMapa(null, { focus: false });
    }
  },
};
</script>
